module.exports = __webpack_public_path__ + "static/media/са.14e0c18b.mp3";